import * as recallApi from '@otter-ai/recall-client';
import { useMutation } from '@tanstack/react-query';

export function useSendPasswordResetMutation({
  onSuccess,
  onError,
}: {
  onSuccess?: (res: recallApi.OkResponse) => void;
  onError?: (error: {
    status?: string;
    message?: string;
    code?: number;
  }) => void;
} = {}) {
  return useMutation<recallApi.OkResponse, Error, string>({
    mutationFn: async (email: string) => {
      const response = await recallApi.sendPasswordReset({
        method: 'POST',
        query: { email },
        body: undefined,
        throwOnError: true,
      });
      return response.data;
    },
    onSuccess,
    onError,
  });
}
